import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
  VerifyDataResponse,
  TipoDocumentComparisonResponse,
} from '../../core/models/organization.models';

export interface GlobalCompareAction {
  kind: 'global';
}

export interface TipoCompareAction {
  kind: 'tipo';
  sectionSlug: string;
  tipoDocumento: string;
  documentType: string;
}

export interface SectionCompareAction {
  kind: 'section';
  sectionSlug: string;
  compareFn: () => Observable<TipoDocumentComparisonResponse>;
}

export type CompareAction = GlobalCompareAction | TipoCompareAction | SectionCompareAction;

/** Optional override: when provided, AdminButtons executes this instead of the global verifyData. */
export type VerifyDataFn = () => Observable<VerifyDataResponse>;

@Injectable({
  providedIn: 'root',
})
export class AdminActionService {
  /** Emits when the Verifica action is triggered.
   * The payload is an optional API override; null/undefined means use the global verifyData endpoint. */
  readonly triggerVerifica$ = new Subject<VerifyDataFn | null>();
  readonly triggerConfronta$ = new Subject<CompareAction>();
}
